export default __webpack_public_path__ + "static/media/bci-4.c80c51f9.svg";